import { useEffect, useRef, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { SelectOption } from "../store/models/DashboardModel";
import { IDataATDP } from "../store/models/CreateAtdp";
import useClientWebSocket from "./useClientWebSocket";
import {
  GetDocumentTypeAC,
  GetFingerDeviceAC,
} from "../store/action-creators/FingerprintActionCreators";
import { getTypeProcessViewCapturadorAC } from "../store/action-creators/TypeProcessActionCreators";
import { IDataFinger } from "../store/models/FingerPrintModel";
import {
  FingerPrintSelector,
  setLoadingFingerPrint,
  setSelectProcess,
} from "../store/slices/FingerPrintSlice";
import { TypeProcessSelector } from "../store/slices/TypeProcessSlice";
import { MESSAGES } from "../utils/types/const";
import {
  getLocationUserStore,
  getUrlWebSocketByRole,
} from "../utils/general/utils";

interface IUseFingerPrintCapture {
  enqueueSnackbar: any;
  roleLogged: "FNA" | "INT" | "ESTANDAR" | "DEMAND" | "NRM";
}

type stateFormParticipants = {
  idParticipant: number;
  stateForm: boolean;
};

const FingerPrintSchema = yup.object().shape({
  procedure: yup
    .string()
    .max(100, `${MESSAGES.max} 100`)
    .required(MESSAGES.required),
});

const useFingerPrintCaptureForm = ({
  enqueueSnackbar,
  roleLogged,
}: IUseFingerPrintCapture) => {
  type FingerPrintFormData = yup.InferType<typeof FingerPrintSchema>;

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FingerPrintFormData>({
    mode: "onSubmit",
    resolver: yupResolver(FingerPrintSchema),
    shouldUnregister: false,
  });

  const dispatch = useDispatch();

  //#region  global states
  const { fingerDevice, loadingFingerPrint } = useSelector(FingerPrintSelector);
  const { typeProcesses, sizeTypeProcess } = useSelector(TypeProcessSelector);

  //#region  local states
  const [isValidDevice, setIsValidDevice] = useState(false);
  const [isOpenModalATPD, setIsOpenModalATPD] = useState(false);
  const [arrayFormsToValidate, setArrayFormsToValidate] = useState<
    Array<stateFormParticipants>
  >([
    {
      idParticipant: 1,
      stateForm: false,
    },
  ]);
  const [numberParticipantsLocal, setNumberParticipantsLocal] =
    useState<number>(1);
  const [submitState, setSubmitState] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [processTypeState, setProcessTypeState] = useState<Array<SelectOption>>(
    []
  );
  const [primaryParticipant, setPrimaryParticipant] = useState<IDataATDP>({
    noCedula: "",
    name: "",
    surname: "",
    place: "",
  });

  // Constants
  var urlSocket = getUrlWebSocketByRole();

  // React hooks
  const {
    connectClientInfo,
    disconnectClientInfo,
    showModalAlertDevice,
    setShowModalAlertDevice,
    responseSocketTemp,
  } = useClientWebSocket(setIsLoading);

  // custom functions

  function handleStatesToFalse() {
    setIsOpenModalATPD(false);
    disconnectClientInfo();
    dispatch(setLoadingFingerPrint(false));
  }
  // handle number participants
  const handleNumberParticipants = (numberParticipantsParam: number) => {
    if (numberParticipantsParam < numberParticipantsLocal) {
      const arrayChanged = arrayFormsToValidate;

      arrayChanged.pop();

      setArrayFormsToValidate(arrayChanged);
    }
    if (numberParticipantsParam >= numberParticipantsLocal) {
      const arr = arrayFormsToValidate;

      arr.push({ idParticipant: numberParticipantsParam, stateForm: false });

      setArrayFormsToValidate(arr);
    }

    let participants = Object.keys(sessionStorage)
      .filter((participant) => !isNaN(Number(participant[0])))
      .filter((participant) => participant > String(numberParticipantsLocal));

    if (participants.length > 0) {
      participants.map((participant) => {
        return sessionStorage.removeItem(participant);
      });
    }

    setNumberParticipantsLocal(numberParticipantsParam);
  };

  // process type selectors
  const returnProcessType = () => {
    typeProcesses?.map((itemProcess: { id: number; name: string }) => {
      const newProcessType: SelectOption = {
        key: itemProcess.id ? itemProcess.id : 1,
        value: itemProcess.name ? itemProcess.name : "",
        label: itemProcess.name ? itemProcess.name : "",
      };

      if (!processTypeState.some((type) => type.key === newProcessType.key)) {
        return setProcessTypeState((prev) => [...prev, newProcessType]);
      }

      return setProcessTypeState((prev) => prev);
    });
  };

  const handleDataSaveForm = (
    data: IDataFinger,
    validate: Function,
    index: number
  ) => {
    if (data.id !== 0) {
      sessionStorage.setItem(data.id.toString(), JSON.stringify(data));
      if (data.id === 1) {
        setPrimaryParticipant({
          name: data.nameuser,
          noCedula: data.documentNumber,
          surname: data.surname,
          place: "",
        });
      }
    }
    validate(index);
  };

  // validate fields fom form
  const handleDisabledSubmit = () => {
    const response = arrayFormsToValidate.every((item) => !!item.stateForm);
    setSubmitState(response);
  };

  const handleValidate = (objectState: stateFormParticipants) => {
    const arr = [...arrayFormsToValidate];
    arr?.map((item) => {
      if (item.idParticipant == objectState.idParticipant) {
        return (item.stateForm = objectState.stateForm);
      }
    });

    setArrayFormsToValidate(arr);
    handleDisabledSubmit();
  };

  const handleProcessType = (valueString: any) => {
    let index = typeProcesses?.findIndex(
      (item: { name: any }) => item.name === valueString
    );

    if ("description" in typeProcesses) {
      dispatch(
        setSelectProcess({
          idProcessType: typeProcesses[index].id ? typeProcesses[index].id : 0,
          descriptionProcess: typeProcesses[index].description,
        })
      );
    } else {
      dispatch(
        setSelectProcess({
          idProcessType: typeProcesses[index].id,
          descriptionProcess: "Sin descripción",
        })
      );
    }
  };

  // Wrap custom action creator for GetFingerprintDevice service and action creator
  const dispatchActionCreatorDevice = (_responseSocketTemp?: any) => {
    const mac = _responseSocketTemp
      ? (_responseSocketTemp.mac || _responseSocketTemp.MAC)
      : (responseSocketTemp.mac || (responseSocketTemp as any).MAC);
    const serial = _responseSocketTemp
      ? (_responseSocketTemp.serial || _responseSocketTemp.deviceSerial)
      : ((responseSocketTemp as any).serial || responseSocketTemp.deviceSerial);

    if (!mac || !serial) return;

    dispatch(
      GetFingerDeviceAC(
        { MAC: mac, serial: serial },
        enqueueSnackbar
      )
    );
  };

  // handle submit
  // dispatch on store response from socket
  const submitForm = () => {
    if (!responseSocketTemp.responseCode || responseSocketTemp.responseCode === "R10") {
      setIsOpenModalATPD(true);
    }
  };

  // Function for closing modal ATDP
  const hideModalATDP = () => {
    setIsOpenModalATPD(false);
  };

  // Open socket connection and validate device
  const connnectDevice = () => {
    /**
     * Guard: evita llamadas duplicadas mientras ya se está conectando.
     * Sin este guard, el useEffect del montaje y el botón "Conectar Dispositivo"
     * podían disparar connnectDevice simultáneamente, causando múltiples
     * peticiones en paralelo al servicio desktop y acumulación de peticiones.
     */
    if (isLoading) return;
    setIsLoading(true);
    connectClientInfo(dispatchActionCreatorDevice);
  };

  //   React hook state
  useEffect(() => {
    sessionStorage.setItem("aes-encrypt", "0");
  }, []);

  /**
   * Guard contra el doble-invoke de efectos de React.StrictMode en desarrollo:
   * el useState `isLoading` no alcanza a frenar la segunda invocación (ocurre
   * en el mismo tick, antes de que el setIsLoading de la primera se refleje),
   * así que se abrían dos cadenas de conexión en paralelo compartiendo el
   * mismo stompClient ref, causando conexiones cruzadas y que el device a
   * veces no se disparara. El ref persiste entre las invocaciones duplicadas
   * de StrictMode (misma instancia de componente), pero se resetea en un
   * montaje real posterior.
   */
  const hasAutoConnectedRef = useRef(false);

  useEffect(() => {
    if (hasAutoConnectedRef.current) return;
    hasAutoConnectedRef.current = true;
    connnectDevice();
  }, []);

  useEffect(() => {
    dispatch(GetDocumentTypeAC());
    dispatch(getTypeProcessViewCapturadorAC());
  }, [sizeTypeProcess]);

  useEffect(() => {
    returnProcessType();
  }, [typeProcesses, sizeTypeProcess]);

  useEffect(() => {
    handleDisabledSubmit();
  }, [arrayFormsToValidate.length]);

  useEffect(() => {
    if (!!showModalAlertDevice) {
      setIsValidDevice(false);
    }
    if (!!fingerDevice && !!fingerDevice.statusCode) {
      if (fingerDevice.statusCode === 200) {
        setIsValidDevice(true);
      } else {
        setIsValidDevice(false);
      }
    }
    if (urlSocket.role === "movil") {
      const position = getLocationUserStore();
      if (!position.latitude && !position.longitude) {
        setIsValidDevice(false);
      }
    }
  }, [fingerDevice, showModalAlertDevice]);

  useEffect(() => {
    if (!!responseSocketTemp.httpStatus) {
      if (!responseSocketTemp.responseCode) {
        enqueueSnackbar(`Conexión con el huellero establecida`, {
          variant: "success",
        });
      } else if (responseSocketTemp.responseCode === "R10") {
        enqueueSnackbar(`${responseSocketTemp.message}`, {
          variant: "success",
        });
        setIsValidDevice(true);
      } else {
        sessionStorage.setItem("aes-encrypt", "0");
        enqueueSnackbar(`${responseSocketTemp.message}`, {
          variant: "error",
        });
        setIsValidDevice(false);
      }
      dispatch(setLoadingFingerPrint(false));
    }
  }, [responseSocketTemp]);

  return {
    handleProcessType,
    handleValidate,
    submitForm,
    handleDataSaveForm,
    handleStatesToFalse,
    handleSubmit,
    handleNumberParticipants,
    hideModalATDP,
    setDeviceAlert: setShowModalAlertDevice,
    connnectDevice,
    control,
    deviceAlert: showModalAlertDevice,
    errors,
    loadingFingerPrint,
    numberParticipantsLocal,
    primaryParticipant,
    processTypeState,
    submitState,
    isOpenModalATPD,
    isValidDevice,
    isLoading,
    responseSocketTemp,
  };
};

export default useFingerPrintCaptureForm;
